import HiwSocial from './HiwSocial';

export default HiwSocial;
